type CookieConsentStatus = {
	analytics: boolean;
	profiling: boolean;
};

/** OneTrust standard cookie category IDs (CookiePro / IAB mapping). */
export const ONETRUST_GROUP_STRICTLY_NECESSARY = 'C0001';
export const ONETRUST_GROUP_PERFORMANCE = 'C0002';
export const ONETRUST_GROUP_FUNCTIONALITY = 'C0003';

declare global {
	interface Window {
		OnetrustActiveGroups?: string;
	}
}

function getOneTrustConsentData(): CookieConsentStatus | undefined {
	if (
		typeof window !== 'undefined' &&
		window?.OnetrustActiveGroups &&
		typeof window?.OnetrustActiveGroups === 'string'
	) {
		return {
			analytics: window.OnetrustActiveGroups.includes('C0002'),
			profiling: window.OnetrustActiveGroups.includes('C0004'),
		};
	}

	return undefined;
}

/**
 * Trustpilot Embedded Review Form requires consent for strictly necessary,
 * performance, and functionality cookies (see Trustpilot integration docs).
 * We align with OneTrust active groups for those categories.
 */
export function hasTrustpilotEmbedConsent(): boolean {
	if (
		typeof window === 'undefined' ||
		!window.OnetrustActiveGroups ||
		typeof window.OnetrustActiveGroups !== 'string'
	) {
		return false;
	}
	const active = window.OnetrustActiveGroups;
	return (
		active.includes(ONETRUST_GROUP_STRICTLY_NECESSARY) &&
		active.includes(ONETRUST_GROUP_PERFORMANCE) &&
		active.includes(ONETRUST_GROUP_FUNCTIONALITY)
	);
}

export default getOneTrustConsentData;
